import { useSessionContext } from '../../contexts/SessionProvider';
import SessionPermissionsLobby from './SessionPermissionsLobby';
import VideoStreamContainer from './VideoStreamContainer';

const SessionContainer = () => {
  // integration of context hooks here
  const { peerInstance } = useSessionContext();

  // rendering session container component here
  return (
    <>
      {peerInstance ? (
        <section className='relative overflow-hidden w-full xl:w-[90%] h-[95%] xl:rounded-xl'>
          <VideoStreamContainer />
        </section>
      ) : (
        <SessionPermissionsLobby />
      )}
    </>
  );
};

export default SessionContainer;
